import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import PaymentLogos from './PaymentLogos'

const PaymentBadgesWrap = styled.div`
  ${tw`flex flex-wrap items-center md:order-2 mb-5 md:mb-0`}
`

const Badge = styled.div`
  ${tw`flex-shrink mr-2 mb-2`}
`

export default function WeAccept() {
  const data = useStaticQuery(graphql`
    query {
      wp {
        globalSettings {
          footer {
            paymentLogos {
              image {
                altText
                id
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FIXED, width: 50, placeholder: NONE, formats: [AUTO, WEBP])
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const { paymentLogos } = data.wp.globalSettings.footer

  return (
    <PaymentBadgesWrap>
      {paymentLogos ? (
        paymentLogos?.map((item) => {
          const image = getImage(item.image?.localFile.childImageSharp)

          return (
            <Badge key={item.image?.id}>
              <GatsbyImage image={image} alt={item.image?.altText} />
            </Badge>
          )
        })
      ) : (
        <PaymentLogos />
      )}
    </PaymentBadgesWrap>
  )
}
